var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2002 24.4519C18.8276 24.4519 24.2002 19.0793 24.2002 12.4519C24.2002 5.82449 18.8276 0.451904 12.2002 0.451904C5.57278 0.451904 0.200195 5.82449 0.200195 12.4519C0.200195 19.0793 5.57278 24.4519 12.2002 24.4519Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 16.6257L8.02591 23.7055C9.32584 24.1879 10.732 24.4518 12.1998 24.4518C17.3593 24.4518 21.7579 21.1953 23.4534 16.6257H6.98242Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98242 8.27801L8.02591 1.1982C9.32584 0.715811 10.732 0.451904 12.1998 0.451904C17.3593 0.451904 21.7579 3.7084 23.4534 8.27801H6.98242Z",
    fill: "#6DA544"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 12.4519C0.200195 17.6114 3.45674 22.0099 8.0263 23.7055V1.19824C3.45674 2.89376 0.200195 7.29227 0.200195 12.4519Z",
    fill: "#A2001D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmirates);
export default __webpack_public_path__ + "static/media/Emirates.253892589b1ce55e3d5692bea7d4631a.svg";
export { ForwardRef as ReactComponent };